import {
  Fund,
  HoldingAccount,
  InvestmentClient,
  InvestmentOrder,
  InvestmentParams,
  LastPerformance
} from 'store/investments/types'
import { instance } from '.'
import { insertKeyEndpoint } from './utils'

interface Response<T> {
  message: string
  data: T
  error: boolean
}

const PERFORMANCE = 'investments/performance'
const INVESTMENT_RESCUE = 'investments/order/rescue'

export const rescueInvestmentService = (
  amount: number,
  isTotalRescue: boolean
) => {
  return instance.post<Response<InvestmentOrder>>(
    insertKeyEndpoint(INVESTMENT_RESCUE),
    { amount, isTotalRescue }
  )
}

export const subscribeInvestmentService = (amount: number) => {
  return instance.post<Response<InvestmentOrder>>(
    insertKeyEndpoint('investments/order/subscription'),
    { amount }
  )
}

export const getPerformanceByClientId = (id: number | string) => {
  return instance.get<Response<any>>(insertKeyEndpoint(`${PERFORMANCE}/${id}`))
}

export const getTutorialCompletion = async () => {
  return instance.get<Response<boolean>>(
    insertKeyEndpoint('investments/tutorial')
  )
}

export const getIsTutorialCompleted = async () => {
  return instance.get<Response<boolean>>(
    insertKeyEndpoint('investments/tutorial-status')
  )
}

export const getInvestmentClient = async () => {
  return instance.get<Response<InvestmentClient>>(
    insertKeyEndpoint('investments/client')
  )
}

export const getTermsheet = async () => {
  return instance.get<Response<string>>(
    insertKeyEndpoint('investments/fund/download_termsheet')
  )
}

export const getFactsheet = async () => {
  return instance.get<Response<string>>(
    insertKeyEndpoint('investments/fund/download_factsheet')
  )
}

export const getHoldingAccount = async () => {
  return instance.get<Response<HoldingAccount>>(
    insertKeyEndpoint('investments/account/holding')
  )
}

export const getLastPerformance = async () => {
  return instance.get<Response<LastPerformance>>(
    insertKeyEndpoint('investments/last-performance')
  )
}

export const getOrders = (body: object) => {
  return instance.post<Response<InvestmentOrder[]>>(
    insertKeyEndpoint('investments/client/orders'),
    body
  )
}

export const getFund = async () => {
  return instance.get<Response<Fund>>(insertKeyEndpoint('investments/fund'))
}

export const getInvestmentParams = async () => {
  return instance.get<Response<InvestmentParams>>(
    insertKeyEndpoint('investments/config-params')
  )
}

export const cancelInvestmentOrder = async (id: number) => {
  return instance.post<Response<InvestmentOrder>>(
    insertKeyEndpoint(`investments/cancel-order/${id}`)
  )
}

export const downloadSummaryMovements = async (body: {
  dateFrom: string
  dateTo: string
}) => {
  return instance.post<Response<any>>(
    insertKeyEndpoint('investments/summary'),
    body
  )
}
